/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PasswordChangeRequest,
    PasswordChangeRequestFromJSON,
    PasswordChangeRequestToJSON,
    UpdateProfileRequest,
    UpdateProfileRequestFromJSON,
    UpdateProfileRequestToJSON,
    User,
    UserFromJSON,
    UserToJSON,
} from '../models';

export interface UpdatePassword2Request {
    passwordChangeRequest: PasswordChangeRequest;
}

export interface UpdateProfileOperationRequest {
    updateProfileRequest: UpdateProfileRequest;
}

/**
 * 
 */
export class AdminProfileApi extends runtime.BaseAPI {

    /**
     * プロフィール取得
     */
    async currentProfileRaw(): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * プロフィール取得
     */
    async currentProfile(): Promise<User> {
        const response = await this.currentProfileRaw();
        return await response.value();
    }

    /**
     * パスワード変更
     */
    async updatePassword2Raw(requestParameters: UpdatePassword2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.passwordChangeRequest === null || requestParameters.passwordChangeRequest === undefined) {
            throw new runtime.RequiredError('passwordChangeRequest','Required parameter requestParameters.passwordChangeRequest was null or undefined when calling updatePassword2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/password`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordChangeRequestToJSON(requestParameters.passwordChangeRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * パスワード変更
     */
    async updatePassword2(passwordChangeRequest: PasswordChangeRequest): Promise<void> {
        await this.updatePassword2Raw({ passwordChangeRequest: passwordChangeRequest });
    }

    /**
     * プロフィール変更
     */
    async updateProfileRaw(requestParameters: UpdateProfileOperationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateProfileRequest === null || requestParameters.updateProfileRequest === undefined) {
            throw new runtime.RequiredError('updateProfileRequest','Required parameter requestParameters.updateProfileRequest was null or undefined when calling updateProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/profile`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileRequestToJSON(requestParameters.updateProfileRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * プロフィール変更
     */
    async updateProfile(updateProfileRequest: UpdateProfileRequest): Promise<void> {
        await this.updateProfileRaw({ updateProfileRequest: updateProfileRequest });
    }

}
